import { useState, useEffect } from 'react';

export const useScheduleTransition = (holidayInformation) => {
  const [showHolidaySchedule, setShowHolidaySchedule] = useState(false);
  const [scheduleTransitioning, setScheduleTransitioning] = useState(false);

  useEffect(() => {
    let interval;
    if (holidayInformation && 
        Object.keys(holidayInformation).length > 0 && 
        holidayInformation.information) {
      interval = setInterval(() => {
        setScheduleTransitioning(true);
        setTimeout(() => {
          setShowHolidaySchedule(prev => !prev);
          setScheduleTransitioning(false);
        }, 300);
      }, 12000);
    }

    return () => {
      if (interval) {
        clearInterval(interval);
      }
    };
  }, [holidayInformation]);

  return {
    showHolidaySchedule,
    scheduleTransitioning
  };
}; 